"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nodes": [// 1: Domains Processors
  {
    "id": "customers",
    "name": "Customers",
    "val": 1,
    "childLinks": []
  }, {
    "id": "customers-rest",
    "name": "REST API",
    "val": 21
  }, {
    "id": "customers-extProc",
    "name": "External Event Processor",
    "val": 66
  }, {
    "id": "products",
    "name": "Products",
    "val": 1,
    "childLinks": []
  }, {
    "id": "products-rest",
    "name": "REST API",
    "val": 21
  }, {
    "id": "products-extProc",
    "name": "External Event Processor",
    "val": 66
  }, {
    "id": "products-int",
    "name": "Integration Layer",
    "val": 48
  }, {
    "id": "customersRelations",
    "name": "Customers Relations",
    "val": 1,
    "childLinks": []
  }, {
    "id": "customersRelations-rest",
    "name": "REST API",
    "val": 21
  }, {
    "id": "customersRelations-intProc",
    "name": "Integration Event Processor",
    "val": 5
  }, {
    // TODO LINKS ///////////////
    "id": "portfolio",
    "name": "Portfolio",
    "val": 1,
    "childLinks": []
  }, ///////////////////////////////
  {
    "id": "documentManager",
    "name": "Document Manager",
    "val": 1,
    "childLinks": []
  }, {
    "id": "documentManager-rest",
    "name": "REST API",
    "val": 21
  }, {
    "id": "users",
    "name": "Users",
    "val": 1,
    "childLinks": []
  }, {
    "id": "users-rest",
    "name": "REST API",
    "val": 21
  }, {
    "id": "users-int",
    "name": "Integration Layer",
    "val": 48
  }, {
    "id": "historyRecords",
    "name": "History Records",
    "val": 1,
    "childLinks": []
  }, {
    "id": "historyRecords-rest",
    "name": "REST API",
    "val": 21
  }, {
    "id": "historyRecords-intProc",
    "name": "Integration Event Processor",
    "val": 5
  }, {
    "id": "historyRecords-extProc",
    "name": "External Event Processor",
    "val": 66
  }, {
    "id": "flows",
    "name": "Flows",
    "val": 1,
    "childLinks": []
  }, {
    "id": "flows-rest",
    "name": "REST API",
    "val": 21
  }, {
    "id": "flows-intProc",
    "name": "Integration Event Processor",
    "val": 5
  }, {
    "id": "flows-extProc",
    "name": "External Event Processor",
    "val": 66
  }, {
    "id": "flows-int",
    "name": "Integration Layer",
    "val": 48
  }, {
    "id": "offers",
    "name": "Offers",
    "val": 1,
    "childLinks": []
  }, {
    "id": "offers-rest",
    "name": "REST API",
    "val": 21
  }, {
    "id": "pricing",
    "name": "Pricing",
    "val": 1,
    "childLinks": []
  }, {
    "id": "pricing-rest",
    "name": "REST API",
    "val": 21
  }, {
    "id": "risk-compliance-rest",
    "name": "REST API",
    "val": 21
  }, {
    "id": "cta",
    "name": "Call to Actions",
    "val": 1,
    "childLinks": []
  }, {
    "id": "cta-rest",
    "name": "REST API",
    "val": 21
  }, {
    "id": "cta-intProc",
    "name": "Integration Event Processor",
    "val": 5
  }, {
    "id": "a1-campaigns",
    "name": "Alpha 1 Campaigns",
    "val": 1,
    "childLinks": []
  }, {
    "id": "a1-campaigns-etl",
    "name": "ETL",
    "val": 66
  }, {
    "id": "a1-campaigns-rest",
    "name": "REST API",
    "val": 21
  }, {
    "id": "a1-campaigns-proc",
    "name": "SPARK",
    "val": 5
  }, {
    "id": "risk-compliance",
    "name": "Risk & Compliance",
    "val": 1,
    "childLinks": []
  }, {
    "id": "myResults",
    "name": "My Results",
    "val": 1,
    "childLinks": []
  }, {
    "id": "myResults-rest",
    "name": "REST API",
    "val": 21
  }, {
    "id": "myResults-intProc",
    "name": "Integration Event Processor",
    "val": 5
  }, {
    "id": "insights",
    "name": "Insights",
    "val": 1,
    "childLinks": []
  }, {
    "id": "insights-rest",
    "name": "REST API",
    "val": 21
  }, {
    "id": "insights-intProc",
    "name": "Integration Event Processor",
    "val": 5
  }, {
    "id": "calendar",
    "name": "Calendar",
    "val": 1,
    "childLinks": []
  }, {
    "id": "calendar-rest",
    "name": "REST API",
    "val": 21
  }, {
    "id": "calendar-int",
    "name": "Integration Layer",
    "val": 48
  }, {
    "id": "dashboard",
    "name": "Dashboard",
    "val": 1,
    "childLinks": []
  }, {
    "id": "dashboard-rest",
    "name": "REST API",
    "val": 21
  }, {
    "id": "customersUsers",
    "name": "Customers Users",
    "val": 1,
    "childLinks": []
  }, {
    "id": "customersUsers-rest",
    "name": "REST API",
    "val": 21
  }, {
    "id": "customersUsers-int",
    "name": "Integration Layer",
    "val": 48
  }, {
    "id": "a1-analytics",
    "name": "Alpha 1 Analytics",
    "val": 1,
    "childLinks": []
  }, {
    "id": "a1-analytics-rest",
    "name": "REST API",
    "val": 21
  }, // 2: Bank Systems
  {
    "id": "productSystems",
    "name": "Bank's Product systems (Core, CC, Insurance)",
    "val": 2
  }, {
    "id": "customerSystems",
    "name": "Bank's Customer systems (Core. BI)",
    "val": 2
  }, {
    "id": "calendarSystems",
    "name": "Bank's Calendar Systems (Office365, Google, Lotus)",
    "val": 2
  }, {
    "id": "identitySystems",
    "name": "Bank's Identity Systems (Active Directory)",
    "val": 2
  }, {
    "id": "documentationSystems",
    "name": "Bank's Systems storing documents",
    "val": 2
  }, // 3: Gateways
  {
    "id": "nowGateway",
    "name": "Now Gateway",
    "val": 3
  }, {
    "id": "spaGateway",
    "name": "SPA Gateway",
    "val": 3
  }, {
    "id": "mobileGateway",
    "name": "Mobile Gateway",
    "val": 3
  }, {
    "id": "a1-campaignsGateway",
    "name": "Alpha 1 Campaigns Gateway",
    "val": 3
  }, {
    "id": "a1-analyticsGateway",
    "name": "Alpha 1 Analytics Gateway",
    "val": 3
  }, // 4: Apps
  {
    "id": "nowWebApp",
    "name": "Now Web App",
    "val": 4
  }, {
    "id": "a1-analyticsWebApp",
    "name": "Agent App",
    "val": 4
  }, {
    "id": "a1-campaignsWebApp",
    "name": "Agent App",
    "val": 4
  }, {
    "id": "mobileApp",
    "name": "Mobile App",
    "val": 4
  }, {
    "id": "OBWalletApp",
    "name": "Onboarding & Wallet App",
    "val": 4
  }, {
    "id": "agentApp",
    "name": "Agent App",
    "val": 4
  }, {
    "id": "onboardingWeb",
    "name": "Onboarding Web",
    "val": 4
  }],
  "links": [// customer oriented
  {
    "source": "customers",
    "target": "customers-rest",
    "type": "inner"
  }, {
    "source": "customers",
    "target": "customers-extProc",
    "type": "inner"
  }, // { ESTA VA A TRAVES DE LA API GATEWAY
  //     "source": "customerSystems",
  //     "target": "customers-rest",
  //    "type": "sync"
  // },
  {
    "source": "customerSystems",
    "target": "customers-extProc",
    "type": "async"
  }, {
    "source": "a1-campaigns",
    "target": "customers-extProc",
    "type": "async"
  }, {
    "source": "a1-analytics",
    "target": "customers-extProc",
    "type": "async"
  }, // products oriented
  {
    "source": "products",
    "target": "products-rest",
    "type": "inner"
  }, {
    "source": "products",
    "target": "products-extProc",
    "type": "inner"
  }, {
    "source": "products",
    "target": "products-int",
    "type": "inner"
  }, {
    "source": "products-int",
    "target": "productSystems",
    "type": "sync"
  }, {
    "source": "productSystems",
    "target": "products-extProc",
    "type": "async"
  }, {
    "source": "a1-campaigns",
    "target": "products-extProc",
    "type": "async"
  }, // Customer Relations Oriented
  {
    "source": "customersRelations",
    "target": "customersRelations-rest",
    "type": "inner"
  }, {
    "source": "customersRelations",
    "target": "customersRelations-intProc",
    "type": "inner"
  }, {
    "source": "products",
    "target": "customersRelations-intProc",
    "type": "async"
  }, {
    "source": "customers",
    "target": "customersRelations-intProc",
    "type": "async"
  }, // Portfolio oriented TODO
  // Document Manager oriented
  {
    "source": "documentManager",
    "target": "documentManager-rest",
    "type": "inner"
  }, {
    "source": "flows",
    "target": "documentManager-rest",
    "type": "sync"
  }, // { ESTA VA A TRAVES DE LA API GATEWAY
  //     "source": "documentationSystems",
  //     "target": "documentManager-rest",
  //    "type": "sync"
  // },
  // Users oriented
  {
    "source": "users",
    "target": "users-rest",
    "type": "inner"
  }, {
    "source": "users",
    "target": "users-int",
    "type": "inner"
  }, {
    "source": "nowGateway",
    "target": "users-rest",
    "type": "sync"
  }, {
    "source": "a1-analyticsGateway",
    "target": "users-rest",
    "type": "sync"
  }, {
    "source": "a1-campaignsGateway",
    "target": "users-rest",
    "type": "sync"
  }, {
    "source": "users-int",
    "target": "identitySystems",
    "type": "sync"
  }, // history records oriented
  {
    "source": "historyRecords",
    "target": "historyRecords-rest",
    "type": "inner"
  }, {
    "source": "historyRecords",
    "target": "historyRecords-intProc",
    "type": "inner"
  }, {
    "source": "historyRecords",
    "target": "historyRecords-extProc",
    "type": "inner"
  }, {
    "source": "products",
    "target": "historyRecords-intProc",
    "type": "async"
  }, {
    "source": "customers",
    "target": "historyRecords-intProc",
    "type": "async"
  }, {
    "source": "cta",
    "target": "historyRecords-intProc",
    "type": "async"
  }, {
    "source": "flows",
    "target": "historyRecords-intProc",
    "type": "async"
  }, {
    "source": "documentManager",
    "target": "historyRecords-intProc",
    "type": "async"
  }, {
    "source": "portfolio",
    "target": "historyRecords-intProc",
    "type": "async"
  }, {
    "source": "customersRelations",
    "target": "historyRecords-intProc",
    "type": "async"
  }, {
    "source": "customerSystems",
    "target": "historyRecords-extProc",
    "type": "async"
  }, //flows oriented
  {
    "source": "flows",
    "target": "flows-rest",
    "type": "inner"
  }, {
    "source": "flows",
    "target": "flows-int",
    "type": "inner"
  }, {
    "source": "flows",
    "target": "flows-intProc",
    "type": "inner"
  }, {
    "source": "flows",
    "target": "flows-extProc",
    "type": "inner"
  }, {
    "source": "flows",
    "target": "documentManager-rest",
    "type": "sync"
  }, {
    "source": "offers",
    "target": "offers-rest",
    "type": "inner"
  }, {
    "source": "flows",
    "target": "offers-rest",
    "type": "sync"
  }, {
    "source": "pricing",
    "target": "pricing-rest",
    "type": "inner"
  }, {
    "source": "offers",
    "target": "pricing-rest",
    "type": "sync"
  }, {
    "source": "risk-compliance",
    "target": "risk-compliance-rest",
    "type": "inner"
  }, {
    "source": "flows",
    "target": "risk-compliance-rest",
    "type": "sync"
  }, {
    "source": "flows-int",
    "target": "customerSystems",
    "type": "inner"
  }, {
    "source": "flows-int",
    "target": "productSystems",
    "type": "inner"
  }, // Call to action oriented
  {
    "source": "cta",
    "target": "cta-rest",
    "type": "inner"
  }, {
    "source": "cta",
    "target": "cta-intProc",
    "type": "inner"
  }, {
    "source": "a1-campaigns",
    "target": "cta-intProc",
    "type": "async"
  }, {
    "source": "cta",
    "target": "a1-campaigns",
    "type": "async"
  }, {
    "source": "flows",
    "target": "cta-rest",
    "type": "sync"
  }, {
    "source": "cta",
    "target": "flows-intProc",
    "type": "async"
  }, // A1 Oriented
  {
    "source": "a1-campaigns",
    "target": "a1-campaigns-rest",
    "type": "inner"
  }, {
    "source": "a1-campaigns",
    "target": "a1-campaigns-proc",
    "type": "inner"
  }, {
    "source": "a1-campaigns",
    "target": "a1-campaigns-etl",
    "type": "inner"
  }, {
    "source": "customerSystems",
    "target": "a1-campaigns-etl",
    "type": "async"
  }, {
    "source": "productSystems",
    "target": "a1-campaigns-etl",
    "type": "async"
  }, {
    "source": "a1-campaignsGateway",
    "target": "a1-campaigns-rest",
    "type": "sync"
  }, {
    "source": "a1-campaigns",
    "target": "customers-extProc",
    "type": "async"
  }, {
    "source": "a1-campaigns-proc",
    "target": "cta-intProc",
    "type": "async"
  }, {
    "source": "a1-campaigns",
    "target": "cta-rest",
    "type": "sync"
  }, {
    "source": "a1-campaigns-proc",
    "target": "myResults-intProc",
    "type": "async"
  }, // my results oriented
  {
    "source": "myResults",
    "target": "myResults-rest",
    "type": "inner"
  }, {
    "source": "myResults",
    "target": "myResults-intProc",
    "type": "inner"
  }, // Insights oriented
  {
    "source": "insights",
    "target": "insights-rest",
    "type": "inner"
  }, {
    "source": "insights",
    "target": "insights-intProc",
    "type": "inner"
  }, {
    "source": "customersRelations",
    "target": "insights-intProc",
    "type": "async"
  }, {
    "source": "portfolio",
    "target": "insights-intProc",
    "type": "async"
  }, {
    "source": "documentManager",
    "target": "insights-intProc",
    "type": "async"
  }, {
    "source": "users",
    "target": "insights-intProc",
    "type": "async"
  }, {
    "source": "historyRecords",
    "target": "insights-intProc",
    "type": "async"
  }, {
    "source": "flows",
    "target": "insights-intProc",
    "type": "async"
  }, {
    "source": "products",
    "target": "insights-intProc",
    "type": "async"
  }, {
    "source": "customers",
    "target": "insights-intProc",
    "type": "async"
  }, {
    "source": "cta",
    "target": "insights-intProc",
    "type": "async"
  }, {
    "source": "calendar",
    "target": "insights-intProc",
    "type": "async"
  }, {
    "source": "nowGateway",
    "target": "insights-rest",
    "type": "sync"
  }, {
    "source": "dashboard",
    "target": "insights-rest",
    "type": "sync"
  }, {
    "source": "insights",
    "target": "myResults-intProc",
    "type": "async"
  }, {
    "source": "dashboard",
    "target": "dashboard-rest",
    "type": "inner"
  }, {
    "source": "nowGateway",
    "target": "dashboard-rest",
    "type": "sync"
  }, // Calendar oriented
  {
    "source": "calendar",
    "target": "calendar-rest",
    "type": "inner"
  }, {
    "source": "calendar",
    "target": "calendar-int",
    "type": "inner"
  }, {
    "source": "calendar-int",
    "target": "calendarSystems",
    "type": "sync"
  }, // Mobile oriented
  {
    "source": "customersUsers",
    "target": "customersUsers-rest",
    "type": "inner"
  }, {
    "source": "customersUsers",
    "target": "customersUsers-int",
    "type": "inner"
  }, {
    "source": "customersUsers-int",
    "target": "customerSystems",
    "type": "sync"
  }, {
    "source": "mobileGateway",
    "target": "customersUsers-rest",
    "type": "sync"
  }, {
    "source": "mobileGateway",
    "target": "customers-rest",
    "type": "sync"
  }, {
    "source": "mobileGateway",
    "target": "products-rest",
    "type": "sync"
  }, {
    "source": "mobileGateway",
    "target": "historyRecords-rest",
    "type": "sync"
  }, {
    "source": "mobileGateway",
    "target": "cta-rest",
    "type": "sync"
  }, {
    "source": "mobileGateway",
    "target": "flows-rest",
    "type": "sync"
  }, {
    "source": "mobileApp",
    "target": "mobileGateway",
    "type": "sync"
  }, // Analytics oriented
  {
    "source": "a1-analytics",
    "target": "a1-analytics-rest",
    "type": "inner"
  }, {
    "source": "a1-campaigns",
    "target": "a1-analytics",
    "type": "inner"
  }, // Gateway oriented
  {
    "source": "nowGateway",
    "target": "customers-rest",
    "type": "sync"
  }, {
    "source": "nowGateway",
    "target": "products-rest",
    "type": "sync"
  }, {
    "source": "nowGateway",
    "target": "historyRecords-rest",
    "type": "sync"
  }, {
    "source": "nowGateway",
    "target": "cta-rest",
    "type": "sync"
  }, {
    "source": "nowGateway",
    "target": "users-rest",
    "type": "sync"
  }, {
    "source": "spaGateway",
    "target": "calendar-rest",
    "type": "sync"
  }, {
    "source": "spaGateway",
    "target": "cta-rest",
    "type": "sync"
  }, {
    "source": "nowGateway",
    "target": "spaGateway",
    "type": "sync"
  }, {
    "source": "a1-analyticsGateway",
    "target": "a1-analytics-rest",
    "type": "sync"
  }, // APPS Oriented
  {
    "source": "nowWebApp",
    "target": "nowGateway",
    "type": "sync"
  }, {
    "source": "a1-campaignsWebApp",
    "target": "a1-campaignsGateway",
    "type": "sync"
  }, {
    "source": "a1-analyticsWebApp",
    "target": "a1-analyticsGateway",
    "type": "sync"
  }, {
    "source": "OBWalletApp",
    "target": "mobileGateway",
    "type": "sync"
  }, {
    "source": "agentApp",
    "target": "nowGateway",
    "type": "sync"
  }, {
    "source": "onboardingWeb",
    "target": "mobileGateway",
    "type": "sync"
  }, // Bank oriented
  {
    "source": "documentationSystems",
    "target": "documentManager-rest",
    "type": "sync"
  }]
};
exports["default"] = _default;